// Timings, sizes and colours for the Forms help layer: one tooltip for the
// whole Forms area, the Help & tours panel and the product tour
// (Implementation List — Oct 7, §3 and §4; design tooltips.js, help.css,
// guide.jsx).

// The one tooltip element; hovered/focused elements point at it with
// aria-describedby while it shows.
export const TIP_ID = 'forms-help-tip';

// Tooltip timing: wait before showing, show at once when moving between tips
// shortly after one hid, and a short grace period before hiding.
export const SHOW_DELAY_MS = 380;
export const WARM_WINDOW_MS = 450;
export const SOFT_HIDE_MS = 70;
// While a tip shows it re-checks its target this often (moved, or removed
// from the page).
export const WATCH_MS = 250;

// Tooltip placement: keep 8px clear of the viewport edge, 9px from the
// target.
export const TIP_MARGIN = 8;
export const TIP_GAP = 9;
// A label up to this long stays on one line.
export const SHORT_LABEL_CHARS = 44;

export const TIP_BG = { dark: '#26263E', light: '#1F2A30' };
export const ORANGE = '#FA4616';

// Phones: the tour card pins to the bottom of the screen with no arrow, and
// the Help panel sits along the bottom edge.
export const MOBILE_MAX = 768;

// Tour: the spotlight's padding around its target, the card's margin from
// the viewport and its gap to the target.
export const TOUR_PAD = 8;
export const CARD_MARGIN = 12;
export const CARD_GAP = 16;
export const CARD_WIDTH = 344;

// Tour timing: each step waits this long for its target before it is
// skipped; the host gets this long to switch screens.
export const TARGET_WAIT_MS = 1400;
export const HOST_WAIT_MS = 2000;
export const POLL_MS = 60;
export const SETUP_GAP_MS = 120;
export const CHAPTER_SETTLE_MS = 280;
export const SCROLL_SETTLE_MS = 90;
export const FOLLOW_MS = 200;

// Above the v3 overlays (ModalOverlay/Drawer 1000, sheets 1100) so the tour
// can point into an open entry card or export dialog.
export const Z = { panel: 1200, tour: 1300, tip: 1400 };
